module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.containerClasses
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchField),
      expression: "searchField"
    }],
    ref: "search",
    class: _vm.placeholderClasses,
    attrs: {
      "readonly": !_vm.search,
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm._s(_vm.searchField)
    },
    on: {
      "blur": _vm.close,
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.searchField = $event.target.value
      }, _vm.inputSearch],
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return; }
        _vm.toggleOpened($event)
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "vuebulmaselect-slide-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opened),
      expression: "opened"
    }],
    class: _vm.optionsClasses,
    style: (_vm.optionsStyles)
  }, [(_vm.options.length === 0) ? [_c('button', {
    staticClass: "button is-white bulma-select__option",
    attrs: {
      "disabled": ""
    }
  }, [_vm._t("no-results", [_vm._v("No options found.")])], 2)] : _vm._l((_vm.options), function(option, i) {
    return _c('button', {
      class: ['button is-white', _vm.selected === i ? 'is-info' : '', 'bulma-select__option'],
      on: {
        "click": function($event) {
          _vm.selectOption(i)
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.label !== undefined ? option[_vm.label] : option) + "\n        ")])
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ecc1af9e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bulma/Select.vue
// module id = 50
// module chunks = 2